import { BarChart as BarChartIcon } from 'lucide-react';

interface EmptyStateProps {
  title: string;
  description: string;
  height?: string;
}

export default function EmptyState({ title, description, height = "h-48" }: EmptyStateProps) {
  return (
    <div className={`${height} flex flex-col items-center justify-center text-gray-500 gap-4`}>
      <div className="w-96 h-32 border-2 border-dashed border-gray-200 rounded-lg flex items-center justify-center bg-gray-50">
        <div className="flex flex-col items-center gap-3">
          <BarChartIcon className="w-12 h-12 text-gray-400" />
          <div className="text-center">
            <p className="text-sm text-gray-600 font-medium">{title}</p>
            <p className="text-sm text-gray-600">{description}</p>
          </div>
        </div>
      </div>
    </div>
  );
}